<template>
  <div
    v-if="isBtoC"
    class="page-block">
    <header-bar v-if="isLoggedIn">キャンペーン情報</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">「narasu（ナラス）」、シングル一枚無料配信キャンペーンを実施！</h3>
    </div>
    <div class="page-block__inner">
      <div class="terms-area">
        <h4 class="terms-text__box pay-off-completely-title">
          新規アカウント登録で、シングル一枚が無料で配信できる！
        </h4>
        <div class="terms-text__box">
          <p>
            音声合成ソフトを利用した楽曲をはじめとするさまざまな楽曲を、
            たくさんのアーティストにnarasuを使って気兼ねなく配信をしていただけるよう、
            シングル一枚を無料で配信できるキャンペーンを実施します！<br>
            このキャンペーンを適用することにより、初期費用と更新費用をかけずに各音楽配信ストアに楽曲を無料で配信できます。
          </p>
          <img
            class="pay-off-completely-campaign-img-202204"
            src="/img/narasu/narasu_campaign_202308b.jpg"
            alt="シングル一枚無料配信キャンペーン告知">
        </div>
        <h4 class="border-box">
          『シングル一枚無料配信キャンペーン』について
        </h4>
        <h4>■ 概要</h4>
        <div class="terms-text__box">
          <p>
            新規アカウント登録で、シングル一枚を無料で配信。<br>
            ※1年ごとの更新費用などは必要ありません。
          </p>
        </div>
        <h4>■ 実施期間</h4>
        <div class="terms-text__box">
          <p>
            2023年8月4日(金) 00:00 〜 2023年10月31日(火) 23:59 アカウント登録分まで。
          </p>
        </div>
        <h4>■ キャンペーン適用方法</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ① narasuに無料アカウント登録すると、クーポンコードが記載されたアカウント登録完了メールが届きます。
            </li>
            <li>
              ② 楽曲の配信申請時、プラン選択項目で「1回払いきりプラン」を選択し、決済方法で「シングル一枚無料配信キャンペーン（初回のみ）」を選択し、クーポンコードを入力します。
            </li>
          </ol>
          <h5 class="how-to-campaign-title">
            ▼キャンペーン選択画面
          </h5>
          <img
            class="pay-off-completely-campaign-adaptation-img-202204"
            src="/img/narasu/pay_off_completely_campaign_adaptation_202308.png"
            alt="払い切りキャンペーン適応手順">
          <h5 class="compar-campaign-title">
            ▼「１回払いきりプラン」他社との配信費用比較
          </h5>
          <img
            class="pay-off-completely-compar-img"
            src="/img/narasu/pay_off_completely_compar_202204.png"
            alt="払い切りキャンペーンの比較">
        </div>
        <h4 class="border-box">
          「narasu（ナラス）」サービス概要
        </h4>
        <img
          class="pay-off-completely-campaign-narasu-logo-img-202004"
          src="/img/narasu/narasu_logo_for_terms.png"
          alt="narasuロゴ">
        <div class="terms-text__box">
          <p>
            SpotifyやApple Musicなどの音楽配信ストアへ、楽曲の登録を代行するサービスです。<br>
            楽曲は何曲でも無制限に配信でき、プロ・アマを問わず音楽を愛する全てのアーティストが、自らの楽曲をより手軽に世界へ向けて発信する機会を提供しています。
          </p>
        </div>
        <img
          class="narasu-business-model-img"
          src="/img/narasu/narasu-business-model.png"
          alt="narasuのビジネスモデル">
        <div class="terms-text__box">
          <p>
            活動のスタンスに合わせて柔軟に選べる料金プランを2種類用意しており、
            国内初のサブスクリプション型（月額定額制）で無制限に配信できる「サブスクプラン」と、
            リリースタイミングに合わせて1回のみ料金を支払う「1回払いきりプラン」があります。<br>
            「1回払いきりプラン」は更新料不要の払いきり価格となっており、楽曲配信を手軽に始めたい方にピッタリのプランです。<br>
            また、YouTubeで自身の楽曲が利用された際に収益化につなげる「YouTubeマネタイズサービス」も提供しています。<br>
            ボーカロイドやその他音声合成ソフトを利用した楽曲の配信も可能で、現在は49キャラクターが利用可能となっています。
          </p>
        </div>
        <div class="terms-text__box">
          <p>
            利用可能VOCALOID™️（その他音声合成ソフトを含む）は以下ページからご確認ください。<br>
            <a
              href="https://narasu.jp/lp/vocalo/#list"
              class="c-text-link"
              target="_blank">https://narasu.jp/lp/vocalo/#list
            </a>
          </p>
          <p class="note">
            ※ご利用の際は、販売収益の内１５％をVOCALOID™️/その他音声合成ソフト利用料として差し引かせていただきます。<br>
          </p>
        </div>
        <div class="terms-text__box">
          <p>narasuはアーティストのフレキシブルな活動をサポートします！</p>
        </div>
        <div
          class="terms-text__box"
          style="margin-top: 80px;">
          <p>
            サイト名：「narasu（ナラス）」<br>
            公式サイト：
            <a
              class="c-text-link"
              href="https://narasu.jp"
              target="_blank">https://narasu.jp
            </a><br>
            <span>
              Twitter：
              <a
                class="c-text-link"
                href="https://twitter.com/narasu_jp"
                target="_blank">https://twitter.com/narasu_jp
              </a><br>
              Instagram：
              <a
                class="c-text-link"
                href="https://www.instagram.com/narasu_jp"
                target="_blank">https://www.instagram.com/narasu_jp
              </a>
            </span><br><br>

            <span>サービス：音楽配信代行サービス</span><br>
            <span>料金プラン：サブスクプラン（月額￥660）および</span><br>
            <span class="price-plan">1回払いきりプラン（シングル：￥2,860／アルバム：￥5,500）</span><br>
            <span>収益還元率：90％</span><br>
            <span>配信エリア：180ヵ国以上</span><br>
            <span>
              配信ストア：Spotify/Apple Music/iTunes Store/Amazon Music Unlimited/Amazonデジタルミュージックストア
              /Prime Music/AWA/LINE MUSIC/楽天MUSIC/YouTube Music<br>
              上記をはじめとする、41ストア
            </span><br>
            <span>※順次新規配信ストアが追加されます。詳細情報は公式HPをご覧ください。</span>
          </p>
        </div>
        <div class="c-btn-wrap">
          <a
            class="c-btn c-btn--back"
            href="https://narasu.jp">
            公式サイトへ
          </a>
          <a
            class="c-btn now-register-btn"
            href="https://narasu.jp/client/sign-up">
            今すぐ登録!!
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'NarasuCampaign202308',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>
